import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';
import toast from 'react-hot-toast';
import { getUserRole, validateSpaces } from '../../Utils/Common';

import { 
    Layout,
    Col, 
    Row,
    Button,
    Dropdown, 
    Space,
    Modal,
    Form,
    Select,
    Input,
} from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { MoreVert  } from '@mui/icons-material';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'

const { Item } = Form;
const { Option } = Select;
const { Search } = Input;
const { confirm } = Modal;

const TaskPersonnel = () => {
  const role_name = getUserRole();
  const [addVisible, setAddVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [personnelId, setPersonnelId] = useState('');
  const [pageSize, setPageSize] = useState('');
  const [personnelDetails, setPersonnelDetails] = useState({
      name: '',
      status:'',
  });
  const [filterConfig, setFilterConfig] = useState({
    search: '',
    type: '',
    personnel_id: '',
    page: 1,
  })
  const [personnelData, setPersonnelData] = useState([])
  const [addForm] = Form.useForm();
  const [editForm] = Form.useForm();
  const { callPost, loading } = usePostRequest(()=>{
    fetchPersonnelData()
    addForm.resetFields();
    editForm.resetFields();
    setAddVisible(false);
    setEditVisible(false);
  });

  const status = [
    {
        value: 'active',
        label: 'Active'
    },
    {
        value: 'inactive',
        label: 'Inactive'
    },
  ]

  function ActionBtn(row) {
    const items = [
        {
            label: (
                <div onClick={()=>showEditModal(row.row.id, row.row)}>
                    Edit
                </div>
            ),
            key: '2',
        },
        {
            label: (
                <div style={{color: 'red'}} onClick={()=>showDeleteConfirm(row.row.id)}>
                    Delete
                </div>
            ),
            key: '3',
        },
    ];

    return (
      <>
        <span className='center'>
          <Dropdown
            menu={{
            items,
            }}
            trigger={['click']}
          >
            <div type='primary' onClick={(e) => e.preventDefault()} className='action-btn'>
              <Space>
                <MoreVert />
              </Space>
            </div>
          </Dropdown>
        </span>
      </>
    );
  }

  async function fetchPersonnelData  () {
    setIsLoading(true)
    const response = await UseGetRequest("personnels/get", filterConfig);
    if (response?.data) {
      setPersonnelData(response?.data?.data);
      setPageSize(response?.data?.size)
    } else {
      setPersonnelData([])
      setPageSize('')
    }

    setIsLoading(false);
  }

  const handleAddOk = () => {
    addForm.validateFields().then(values => {
      callPost(
        "personnels/create", 
        values,
        false
      );
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };
  
  const handleEditOk = () => {
    editForm.validateFields().then(values => {
      const resetData = {
        ...values,
        personnel_id: personnelId
      }
      callPost(
        "personnels/update", 
        resetData,
        false
      );      
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };

  const showAddModal = () => {
    setAddVisible(true);
  };

  const showEditModal = (id, personnel_data) => {
    setPersonnelId(id) 
    setPersonnelDetails(() => ({
      name: personnel_data.name,
      status: personnel_data.status,
    })); 

    editForm.setFieldsValue({
      name: personnel_data.name,
      status: personnel_data.status,
    });
    setEditVisible(true);
  };


  const handleAddCancel = () => {
    addForm.resetFields();
    setAddVisible(false);
  };

  const handleEditCancel = () => {
    editForm.resetFields();
    setEditVisible(false);
  };

  const showDeleteConfirm = (id) => {
    confirm({
      title: 'Do you want to permanently remove this Personnel?',
      icon: <ExclamationCircleFilled/>,
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      okButtonProps: {
        className: 'custom-yes-button',
      },
      cancelButtonProps: {
        className: 'custom-no-button',
      },
      confirmLoading: loading,
      onOk() {
        callPost(
          "personnels/delete", 
          {personnel_id: id},
          false
        );
      },
    });
  }; 

  const handleSearchChange = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        search: e || '',
        page: 1,
      }
    ));
  };

  const handleEmpty = (e) => {
    if(e.target.value === ''){
      setFilterConfig((prev) => (
        {
          ...prev,
          search: e.target.value || '',
          page: 1,
        }
      ));
    }
  };

  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      page_size: pagination.pageSize
      // total_records_per_page: pagination.pageSize,
    }));
  };

  useEffect(() => {
    fetchPersonnelData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  return (
    <Layout className='page'>
        <Navbar navKey={'personnel_task_nav'}/>
        <Layout className='content-container overflow-y'>
          <Row className='custom-padding responsive-tab-inline'>
            <Col span={9} className='header-container'>
              PERSONNEL
            </Col>
            <Col span={15} className='mt-2 responsive-tab-width' align='end'>
              <Space className='responsive-inline'> 
                {
                  role_name === "Administrator"  && (
                    <Button 
                      className='button-color responsive-header-btn' 
                      onClick={showAddModal} 
                      type="primary"
                    >
                      + Add Personnel
                    </Button>
                  )
                }
              </Space>
            </Col>
          </Row>
          <Row>
            <Space span={24} className='responsive-inline excel-row'>
              <Search
                placeholder="Search..."
                size='medium'
                onSearch={(e)=>handleSearchChange(e)}
                onChange={(e)=>handleEmpty(e)}
                className='responsive-header-input'
              />              
            </Space>
          </Row>
          <Row className='page-content'>
            <Col span={24} className='responsive-overflow-auto'>
              <AntDTable
                tableHeaders={[
                  "Name",
                  "Status",
                ]}
                headerSelector={[
                  "name",
                  "status",
                ]}
                tableData={personnelData}
                ActionBtn={(row) => ActionBtn(row)}
                withAction={role_name === "Administrator"}
                loading={isLoading}
                tablePages={10}
                handleTableChange={handleTableChange}
                filterConfig={filterConfig}
                totalSize={pageSize}
                isSearch={true}
              />
            </Col>
          </Row>
        </Layout>
        <Modal
          title="Add Personnel"
          confirmLoading={loading}
          open={addVisible}
          onOk={handleAddOk}
          onCancel={handleAddCancel}
          okText="Submit"
          maskClosable={false}
        >
          <Form 
            form={addForm} 
            layout="vertical"
          >
            <Item
                label="Name"
                name="name"
                rules={[
                  { required: true, message: 'Please enter your Name!' },
                  { validator: validateSpaces }
                ]}
                
            >
                <Input />
            </Item>
            <Item
                label="Status"
                name="status"
                rules={[
                  { required: true, message: 'Please enter your Status!' },
                  { validator: validateSpaces }
                ]}
            >
                <Select 
                    placeholder="Select a Status" 
                    className='select-field responsive-header-input'
                    showSearch
                    allowClear
                    align='left'
                    filterOption={(input, option) =>
                        option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                >
                    {status.map((option) => (
                        <Option key={option.value} value={option.value}>{option.label}</Option>
                    ))}
                </Select>
            </Item>
          </Form>
        </Modal>
        <Modal
          title="Edit Personnel"
          confirmLoading={loading}
          open={editVisible}
          onOk={handleEditOk}
          onCancel={handleEditCancel}
          okText="Save"
          maskClosable={false}
        >
            <Form 
                form={editForm} 
                layout="vertical"
                initialValues={personnelDetails}
            >
                <Item
                    label="Name"
                    name="name"
                    rules={[
                    { required: true, message: 'Please enter your Name!' },
                    { validator: validateSpaces }
                    ]}
                    
                >
                    <Input />
                </Item>
                <Item
                    label="Status"
                    name="status"
                    rules={[
                      { required: true, message: 'Please enter your Status!' },
                      { validator: validateSpaces }
                    ]}
                >
                    <Select 
                        placeholder="Select a Status" 
                        className='select-field responsive-header-input'
                        showSearch
                        allowClear
                        align='left'
                        filterOption={(input, option) =>
                            option?.children?.toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {status.map((option) => (
                            <Option key={option.value} value={option.value}>{option.label}</Option>
                        ))}
                    </Select>
                </Item>
            </Form>
        </Modal>
    </Layout>
  )
}

export default TaskPersonnel
